import { map, tap } from 'rxjs/operators';
import { AppInjector } from './../../src/core/injector/injector.module';
import { LoginGuard } from '@m4u-angular/core/framework/login.guard';
import { Enums, EnumUserTypes } from '@dato-proxy/enums';
import { BaseDataSourceAbstract } from '@m4u-angular/base/datalayer/BaseDataSourceAbstract';
import { of, Observable, zip } from 'rxjs';
import { AppConfig } from '@m4u-angular/configuration/app.config.model';
import { AgingReportGridComponent } from './pages/reports/Components/aging-report-grid/aging-report-grid.component';
import { ContactPersonComponent } from './pages/contact-person/contact-person.component';
import { CustomerAddressComponent } from './pages/customer-address/customer-address.component';
import { DeliveryGridComponent } from './pages/reports/Components/delivery-grid/delivery-grid.component';
import { GoFromDocumentCodeComponent } from './pages/go-from-document-code/go-from-document-code.component';
import { InvoiceGridComponent } from './pages/reports/Components/invoice-grid/invoice-grid.component';
import { LedgerGridComponent } from './pages/reports/Components/ledger-grid/ledger-grid.component';
import { ChangeCreditCardDialogComponent } from './pages/my-details/Components/change-credit-card-dialog/change-credit-card.component';
import { ContactPersonGridComponent } from './pages/my-details/Components/contact-person-grid/contact-person-grid.component';
import { CustomerAddressGridComponent } from './pages/my-details/Components/customer-address-grid/customer-address-grid.component';
import { MyDetailsComponent } from './pages/my-details/my-details.component';
import { PdfPageComponent } from './pages/pdf-page/pdf-page.component';
import { FormatPriceWithCurrencyPipe } from './pipes/format-price-with-currency.pipe';
import { AgingTransDocumentEndpoint } from '@dato-proxy/endpoints/agingtransdocument.endpoint';
import { ContactPersonEndpoint } from '@dato-proxy/endpoints/contactperson.endpoint';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { CustomerAddressEndpoint } from '@dato-proxy/endpoints/customeraddress.endpoint';
import { DeliveryEndpoint } from '@dato-proxy/endpoints/delivery.endpoint';
import { InvoiceEndpoint } from '@dato-proxy/endpoints/invoice.endpoint';
import { LedgerEndpoint } from '@dato-proxy/endpoints/ledger.endpoint';
import { LoginRequestEndpoint } from '@dato-proxy/endpoints/loginrequest.endpoint';
import { PaymentRequestEndpoint } from '@dato-proxy/endpoints/paymentrequest.endpoint';
import { PdfEndpoint } from '@dato-proxy/endpoints/pdf.endpoint';
import { SystemOptionEndpoint } from '@dato-proxy/endpoints/systemoption.endpoint';
import { DefaultRouteParams, MainMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { Routes } from '@angular/router';
import { Globals } from './_globals';
import { ReportsComponent } from './pages/reports/reports.component';
import { Lists_EN } from './_resources/LISTS_EN';
import { Lists_HE } from './_resources/LISTS_HE';
import { BankDetailsComponent } from './pages/bank-details/bank-details.component';
import { FileEndpoint } from '@dato-proxy/endpoints/file.endpoint';
import { FileListDialogComponent } from './dialogs/file-list-dialog/file-list-dialog.component';
import { OptionsComponent } from './pages/options/options.component';
import { PaymentRequestReportComponent } from './pages/payment-request-report/payment-request-report.component';
import { PaymentRequestGridComponent } from './pages/payment-request-report/Components/payment-request-grid/payment-request-grid.component';
import { PaymentRequestStepGridComponent } from './pages/payment-request-report/Components/payment-request-step-grid/payment-request-step-grid.component';
import { PaymentRequestLineDocumentComponent } from './pages/payment-request-report/Components/payment-request-line-document/payment-request-line-document.component';
import { FormatPriceWithCurrencyDirective } from './directives/format-price-with-currency.directive';
import { TestOptionsDialogComponent } from '@dato-dialogs/test-options-dialog/test-options-dialog.component';
import { UserEndpoint } from '@dato-proxy/endpoints/user.endpoint';
import { CompanyEndpoint } from '@dato-proxy/endpoints/company.endpoint';
import { DocumentLineGridComponent } from '@dato-pages/payment-request/Components/document-line-grid/document-line-grid.component';
import { DocumentEndpoint } from '@dato-proxy/endpoints/document.endpoint';
import { PaymentDialogComponent } from '@dato-dialogs/payment-dialog/payment-dialog.component';
import { ReportsMobileComponent } from '@dato-pages/reports/mobile/reports-mobile/reports-mobile.component';
import { TotalBalanceComponent } from '@dato-pages/reports/Components/total-balance/total-balance.component';
import { LedgerListComponent } from '@dato-pages/reports/mobile/ledger-list/ledger-list.component';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { DocumentLineListComponent } from '@dato-pages/reports/mobile/document-line-list/document-line-list.component';
import { InvoiceListComponent } from '@dato-pages/reports/mobile/invoice-list/invoice-list.component';
import { DeliveryListComponent } from '@dato-pages/reports/mobile/delivery-list/delivery-list.component';
import { ContactPersonListComponent } from '@dato-pages/my-details/Components/contact-person-list/contact-person-list.component';
import { CustomerAddressListComponent } from '@dato-pages/my-details/Components/customer-address-list/customer-address-list.component';
import { CredentialSelectorComponent } from '@dato-pages/credential-selector/credential-selector.component';
import { PaymentResultComponent } from '@dato-pages/payment-result/payment-result.component';

class DatoAppConfig extends AppConfig {
    override ModuleName = 'Dato';

    override Components = [
        GoFromDocumentCodeComponent,
        PdfPageComponent,
        MyDetailsComponent,
        ContactPersonGridComponent,
        ContactPersonComponent,
        CustomerAddressGridComponent,
        CustomerAddressComponent,
        ChangeCreditCardDialogComponent,
        FormatPriceWithCurrencyPipe,
        ReportsComponent,
        AgingReportGridComponent,
        DeliveryGridComponent,
        InvoiceGridComponent,
        LedgerGridComponent,
        BankDetailsComponent,
        FileListDialogComponent,
        OptionsComponent,
        PaymentRequestReportComponent,
        PaymentRequestGridComponent,
        PaymentRequestStepGridComponent,
        PaymentRequestLineDocumentComponent,
        FormatPriceWithCurrencyDirective,
        TestOptionsDialogComponent,
        DocumentLineGridComponent,
        PaymentDialogComponent,
        ReportsMobileComponent,
        TotalBalanceComponent,
        LedgerListComponent,
        InvoiceListComponent,
        DeliveryListComponent,
        DocumentLineListComponent,
        ContactPersonListComponent,
        CustomerAddressListComponent,
        CredentialSelectorComponent,
        PaymentResultComponent
    ];

    override Endpoints = [
        LedgerEndpoint,
        InvoiceEndpoint,
        PaymentRequestEndpoint,
        LoginRequestEndpoint,
        AgingTransDocumentEndpoint,
        PdfEndpoint,
        CustomerEndpoint,
        ContactPersonEndpoint,
        CustomerAddressEndpoint,
        DeliveryEndpoint,
        SystemOptionEndpoint,
        FileEndpoint,
        UserEndpoint,
        CompanyEndpoint,
        DocumentEndpoint
    ];

    override RoutesProtected: Routes = [
        { path: 'my-details', component: MyDetailsComponent, data: { Menu: 'my-details' }, canActivate: [LoginGuard] },
        { path: 'pdf_view/:EntryID', component: PdfPageComponent, canActivate: [LoginGuard] },
        { path: 'pdf_view/:EntryID', component: PdfPageComponent, canActivate: [LoginGuard], outlet: 'window' },
        { path: 'reports', component: ReportsComponent, data: { Menu: 'reports' }, canActivate: [LoginGuard] },
        { path: 'accounting', component: ReportsMobileComponent, data: { Menu: 'accounting' }, canActivate: [LoginGuard] },
        { path: 'contact-person/:EntryID', component: ContactPersonComponent, canActivate: [LoginGuard], outlet: 'window' },
        { path: 'customer-address/:EntryID', component: CustomerAddressComponent, canActivate: [LoginGuard], outlet: 'window' },
        { path: 'bank-details', component: BankDetailsComponent, canActivate: [LoginGuard], outlet: 'window' },
        { path: 'impersonate', component: CredentialSelectorComponent, data: { Menu: 'impersonate' }, canActivate: [LoginGuard], outlet: 'window' },

        { path: 'options', component: OptionsComponent, canActivate: [LoginGuard], data: { Menu: 'options', Hello: 'world' } },
        { path: 'payments-report', component: PaymentRequestReportComponent, canActivate: [LoginGuard] },
        { path: 'payment-result', component: PaymentResultComponent, canActivate: [LoginGuard] }
    ];
    override RoutesWithEmptyLayout: Routes = [
        { path: 'go_from_document_code', component: GoFromDocumentCodeComponent },
        { path: 'pdf_view_np/:EntryID', component: PdfPageComponent, canActivate: [LoginGuard] },
    ];
    override Enums = Enums;

    override OnGetMenu = () => {
        const screen = AppInjector.get(ScreenService);

        return of([
            new MainMenuElement('reports', '/pages/reports', 'mdi mdi-bank', undefined, () => Globals.IsAllowAccounting(), undefined, false),
            new MainMenuElement('accounting', '/pages/accounting', 'mdi mdi-bank', undefined, () => Globals.IsAllowAccounting() && screen.IsMobile()),
            new MainMenuElement('my-details', '/pages/my-details', 'mdi mdi-cog-outline', undefined, () =>  Globals.SystemOption.IsAllowMyDetails),
            new MainMenuElement('impersonate', '/pages/impersonate', 'mdi mdi-account-multiple', undefined, (userInfo?: any) => userInfo.UserType === EnumUserTypes.Admin),
            
            new MainMenuElement('admin_settings', undefined, 'mdi mdi-cogs', undefined, (userInfo?: any) => userInfo.UserType === EnumUserTypes.Admin, undefined, false, [
                new MainMenuElement('options', '/pages/options', 'mdi mdi-wrench'),
                new MainMenuElement('system_options', '/pages/general/system-options', 'mdi mdi-hammer-wrench'),
                new MainMenuElement('notification_servers', '/pages/general/notification-servers', 'mdi mdi-email-send'),
                new MainMenuElement('notification_templates', '/pages/general/notification-templates', 'mdi mdi-email-multiple')
            ]),
            new MainMenuElement('system_reports', undefined, 'mdi mdi-folder', undefined, (userInfo?: any) => userInfo.UserType === EnumUserTypes.Admin, undefined, false, [
                new MainMenuElement('payments_report', '/pages/payments-report', 'mdi mdi-cash-multiple'),
                new MainMenuElement('notificationshistory', '/pages/general/notificationshistory', 'dx-icon dx-icon-message'),
                new MainMenuElement('usersactivitystatus', '/pages/general/usersactivitystatus', 'mdi mdi-account-circle'),
                new MainMenuElement('user_login_history', '/pages/general/user-login-history', 'mdi mdi-account-circle'),
                new MainMenuElement('request_history', '/pages/general/requests-history', 'mdi mdi-access-point')
            ]),

        ]);
    }

    override OnGetDefaultRouteParams = (userInfo?: any) => {
        if (Globals.SystemOption) return of(this.GetDefaultRouteParams());

        return this.OnInitApplicationAsync().pipe(
            map(() => this.GetDefaultRouteParams())
        );
    }

    private GetDefaultRouteParams() {
        const screen = AppInjector.get(ScreenService);

        const defaultRouteParams = new DefaultRouteParams();
        defaultRouteParams.Route = Globals.IsAllowAccounting() 
            ? screen.IsMobile()
                ? '/pages/accounting'
                : '/pages/reports'
            : Globals.SystemOption.IsAllowMyDetails 
                ? '/pages/my-details'
                : '/pages/options';
        
        return defaultRouteParams;
    }

    override OnGetGlobalDataSources = (): Observable<{ [id: string]: BaseDataSourceAbstract }> => {
        // Static datasources
        const staticDataSources = {};

        (Object as any).values(staticDataSources).forEach(x => x.Data.load());

        // Live datasources
        const liveDataSources = {};

        return of({ ...staticDataSources, ...liveDataSources });
    }

    override OnInitApplicationAsync = (): Observable<boolean> => {
        const systemOptionEndpoint = AppInjector.get(SystemOptionEndpoint);
        const userEndpoint = AppInjector.get(UserEndpoint);

        return zip(systemOptionEndpoint.GetCurrent(), userEndpoint.IsActiveUser()).pipe(
            tap((x) => {
                Globals.SystemOption = x[0].Entity;
                Globals.IsActiveUser = x[1].Data;
            }),
            map(() => true)
        );
    }

    override GetLists = () => [Lists_EN, Lists_HE];
}

export const appConfig: AppConfig = new DatoAppConfig();
